<template>
  <div class="purchaseContractCreation">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <!--基本信息-->
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基本信息
          </div>
        </template>
        <div class="collapse-content">
          <SiruiSearch
            ref="formItem"
            :query="baseFormData"
            :columns="formColumList"
            :isQueryPanel="false"
            :rules="computedFormRule"
            @changeMethod="changeMethod"
            :isDisabledForm="isDisabledForm"
          >
          </SiruiSearch>
          <!-- <el-form label-width="100px" ref="otherForm" :label-position="'right'" :model="remark">
            <el-form-item label="备注" prop="mark">
              <el-input
                :maxlength="256"
                v-model="remark.mark"
                placeholder="请输入信息"
                clearable
              ></el-input>
            </el-form-item>
          </el-form> -->
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            产品明细
          </div>
        </template>
        <div class="collapse-content">
          <el-tabs type="card" v-model="tabActiveName" class="common-tab">
            <el-tab-pane :label="$t('salePurchase.add.product')" name="first">
              <div class="detail">
                <ContractTable
                  ref="orderDetailListRef"
                  :defaultTableData="orderDetailList"
                  :baseFormData="baseFormData"
                  :detailPageData="detailPageData"
                  :fileType="fileType"
                  @closeTableHandler="closeTableHandler"
                  @isDisabledIsRestrict="isDisabledIsRestrict"
                />
              </div>
            </el-tab-pane>
            <!--利息计算-->
            <el-tab-pane label="利息计算" name="second" v-if="isShowOverdueInterestTab">
              <div class="detail">
                <OverdueInterest
                  :isEdit="isEdit"
                  ref="overdueInterestRef"
                  :isDisableOverdueInterest="isDisableOverdueInterest"
                  :orderInterest="orderInterest"
                ></OverdueInterest>
              </div>
            </el-tab-pane>
            <!--关联信息-->
            <el-tab-pane :label="$t('salePurchase.add.relation')" name="fouth">
              <div class="detail">
                <RelationInfoTable
                  :isEdit="isEdit"
                  ref="relationInfo"
                  :defaultData="orderContractRelationshipList"
                ></RelationInfoTable>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-collapse-item>
      <!--备注,只有勾选生成销售合同才有-->
      <!-- <el-collapse-item name="3" v-if="baseFormData.isGenerateSales">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            备注
          </div>
        </template>
        <div class="collapse-content">
          <el-row :gutter="10" style="padding: 0 20px">
            <el-col :span="24">
            </el-col>
          </el-row>
        </div>
      </el-collapse-item> -->
      <!--附件-->
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre"> <span></span>附件上传 </div>
        </template>
        <div class="collapse-content">
          <!-- <FileTable ref="fileTableRef" :attachments="attachments" :isShowDownBtn="isShowDownBtn" /> -->
          <IEUploadFileType
            ref="fileTableRef"
            :tableData="attachments || []"
            @upload="handleUpload"
            :isShowDownBtn="isShowDownBtn"
            dictType="CONTRACT_INITIATION"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <ContractBtn :contractStatus="contractStatus" @btnHandler="btnGroupHandler" />
  </div>
</template>
<script>
  // import formItem from '../components/form-item';
  import RelationInfoTable from './components/RelationInfoTable/index.vue';
  import OverdueInterest from './components/OverdueInterest/index.vue';
  import purchaseAgreementCreationMixin from './purchaseAgreementCreationMixin.js';
  import ContractTable from './components/ContractTable/index.vue';
  import ContractBtn from './components/FooterBtnGroup/ContractBtn.vue';
  import purchaseEditFormFieldMixin from './purchaseEditFormFieldMixin.js';
  import purchaseTrimFormFieldMixin from './purchaseTrimFormFieldMixin.js';
  import { baseFormColum, formRule } from './contractForm.js';
  export default {
    name: 'purchaseContractCreation',
    components: {
      // formItem,
      RelationInfoTable,
      OverdueInterest,
      ContractTable,
      ContractBtn,
    },
    mixins: [
      purchaseTrimFormFieldMixin,
      purchaseAgreementCreationMixin,
      purchaseEditFormFieldMixin,
    ],
    data() {
      return {
        selectCompanyCode: '',
        isSales: false, //销售是sales，采购是purchase,标志符true代表传sales
        showExtraSwitch: false,
        activeNames: ['1', '2', '3'],
        tabActiveName: 'first',
        pricingRule: false,
        pricingRuleDisabled: true,
        //预付金额是否必填
        creditAmountDisabled: false,
        hedgingTypeDisabled: false,
        fileType: 'contract', // 当前是采购合同

        remark: {
          mark: null,
        },
        //附件
        uploadTableData: [],
        load: false,
        orderDetailList: [],
        orderContractRelationshipList: [],
      };
    },
    computed: {
      isEdit() {
        return this.$route.query.isEdit ? JSON.parse(this.$route.query.isEdit) : false;
      },
      formColumList() {
        return baseFormColum(this);
      },
      computedFormRule() {
        return formRule(this);
      },
    },
    methods: {
      isDisabledIsRestrict(isDisabled) {
        console.log(isDisabled, '是否禁用');
        this.disabledIsRestrict = isDisabled;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .prodcut {
    margin-bottom: 11px;
    background-color: #fff;
  }

  .detail {
    padding-bottom: 0px;
  }

  .collapse-main-content {
    margin-bottom: 10px;
  }
</style>
